import dayjs from '@skynet/formatting-date';

export const parseMessage = (rawMessage: string) => {
  const firstGtIndex = rawMessage.indexOf('>');
  if (firstGtIndex !== -1) {
    const potentialDate = rawMessage.substring(0, firstGtIndex);
    // Check if it looks like a date (DD.MM.YYYY HH:mm format)
    if (/^\d{2}\.\d{2}\.\d{4} \d{2}:\d{2}$/.test(potentialDate)) {
      return {
        datetime: potentialDate,
        message: rawMessage.substring(firstGtIndex + 1),
      };
    }
  }
  return {
    datetime: dayjs().utc().format('DD.MM.YYYY HH:mm'),
    message: rawMessage,
  };
};
